/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import MainMenu from './MainMenu';

import Button from '../ingka/Button';
import Text from '../ingka/Text';
import style from './header.module.scss'
import chevronDown from '@ingka/ssr-icon/paths/menu'
import back from '@ingka/ssr-icon/paths/arrow-left'
import cross from '@ingka/ssr-icon/paths/cross'
import logoutIcon from '@ingka/ssr-icon/paths/arrow-right-from-base'
import { NavLink, useNavigate } from 'react-router-dom';

import SelectIngka from '../ingka/SelectIngka';
import SSRIcon from '@ingka/ssr-icon';
import chevronRight from "@ingka/ssr-icon/paths/chevron-right-small";
import MotionLevelSelector from './MotionLevelSelector';
import Select from "./Select";

import fullScreenIcon from '@ingka/ssr-icon/paths/fullscreen'
import { ROL } from '../../configuration/globalConstants';
import { useSessionStore } from '../../store/sessionStore';
import { useCanvasStore } from '../../store/canvasStore';
import { useStores } from '../../hooks/use-stores';
import { useSettingStore } from '../../store/settingStore';
import { useLanguages } from '../../hooks/use-languages';

export default function Header() {
  const[clicked, setClicked] = useState(false)
  const [t, i18n] = useTranslation("global")
  const { rol, language, route, page, myStore, clearRoute,  doLogout, setMyStore, changeLang } = useSessionStore()
  const { maps, clearAllMaps } = useCanvasStore()
  const { resetSettings } = useSettingStore()
  const { storeOptions, isLoadingStores } = useStores()
  const [levelSelected, setLevelSelected] = useState(null)
  const [showSelector, setShowSelector] = useState(false)
  const [showRoute, setShowRoute] = useState(false)
  const [store, setStore] = useState(null)
  const navigate = useNavigate()
  const [fullScreen, setFullScreen] = useState(false)
  const { languagesOptions } = useLanguages()

  useEffect(() => {
    
    if(page !== "map"){
      setShowRoute(false)
    }else{
      setShowRoute(true)
    }
  },[page])

  
  const changeLanguage = (e)=>{
    changeLang(e.target.value)
    i18n.changeLanguage(e.target.value)
    toggleMenu()
  }

  const toggleMenu = ()=>{
    setClicked(!clicked)
  }

  const logout = (e)=>{
    e.preventDefault()
    doLogout()
    clearAllMaps()
    resetSettings()
  }

  const backToStart = () => {
    navigate(route[0].back, {replace: true})
    clearRoute(null)
  }

  const openSelector = (level) => {
    toggleMenu()
    setLevelSelected(level)
    setShowSelector(true)
  }

  useEffect(() => {
    if(rol.id === ROL.SUPERADMIN){
      setStore({label: myStore.name, value: myStore.id})
    }
  }, [rol])

  const changeStore = (val) => {
    console.log(val)
    setStore(val)
    clearAllMaps()
    setMyStore({id: val.value, name: val.label})
    navigate('/')
  }

  const toggleFullScreen = () => {
    const docEl = document.documentElement;

    if (!fullScreen) {
      if (docEl.requestFullscreen) {
        docEl.requestFullscreen();
      } else if (docEl.mozRequestFullScreen) { // Firefox
        docEl.mozRequestFullScreen();
      } else if (docEl.webkitRequestFullscreen) { // Chrome, Safari, Opera
        docEl.webkitRequestFullscreen();
      } else if (docEl.msRequestFullscreen) { // IE/Edge
        docEl.msRequestFullscreen();
      } else {
        docEl.style.height = "100vh";
        docEl.style.width = "100vw";
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { // Chrome, Safari, Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen();
      } else {
        docEl.style.height = "";
        docEl.style.width = "";
      }
    }
    setFullScreen(!fullScreen);
  }

  return (
    <>
      <div className={style.header} >
        <div className='container-header'>
          <div className={style.left}>
          {!showRoute &&
            <>
              <Button 
                type="tertiary" 
                iconOnly 
                small
                ssrIcon={chevronDown} 
                className={style.ham_btn}
                onClick={()=>toggleMenu()}
              />
            
              <NavLink to="/" className={style.title}>
                <Text 
                  tagName="h1" 
                  headingSize="m" 
                  >
                    <span>Customer </span>
                    <span>Flow</span>
                </Text>
              </NavLink>
            </>
          }
          {showRoute && route &&
            <>
              <Button 
              type="tertiary" 
              iconOnly 
              small
              ssrIcon={back} 
              className={style.ham_btn}
              onClick={backToStart}
              />
              {
                route.map((item,index) => {
                  if(route.length-1 === index){
                    return(
                      <Text tagName="h1" headingSize="s" key={index} className={style.lastTitle}>
                        {item.back === "/maps" ? maps.find(map=> map.id ===item.id).name : item.title}
                      </Text>
                    )
                  } else {
                    return(
                      <NavLink to={item.path} className={style.route} key={index} onClick={() =>clearRoute(item.title)}>
                        <Text tagName="h1" headingSize="s" className={style.title}>
                          {item.back === "/maps" ? maps.find(map=> map.id ===item.id).name : item.title}
                          <SSRIcon paths={chevronRight} />
                          </Text>
                      </NavLink>
                    )
                  }
                })
              }
            </>
          }
            
          </div>

          <div className={style.right}>
            {rol.id === ROL.SUPERADMIN && 
              <Select
              formField={{className: style.storeSelector}}
              onChange={val => changeStore(val)}
              defaultValue={store}
              value={store}
              isClearable={false}
              isSearchable={true}
              id="store"
              name="store"
              options={storeOptions}
              isLoading={isLoadingStores}
            />
            }
            <Button 
              className={`${style.fullScreen} ${fullScreen && style.activeFullScreen}`}
              type="tertiary" 
              iconOnly 
              small 
              ssrIcon={fullScreenIcon} 
              onClick={()=> toggleFullScreen()}
            />
          </div>

          {/* Side menu */}
          <aside className={`${style.side_menu} ${clicked ? style.open : ''}`}>
            <div className={style.side_menu_header}>
            <Text 
              tagName="h1" 
              headingSize="m" 
              className={style.title}>
                <span>Customer </span>
                <span>Flow</span>
            </Text>
              <Button 
                type="tertiary" 
                iconOnly 
                small 
                ssrIcon={cross} 
                onClick={()=>toggleMenu()}
              />
            </div>
            <div className={style.side_menu_body}>
              <MainMenu changeView={()=>toggleMenu()} openSelector={openSelector}/>
            </div>
            <div className={style.side_menu_footer}>
              <SelectIngka
                select={{
                  onChange: changeLanguage,
                  id: "langSelector",
                  value: language,
                }}
                options={languagesOptions}
              />
              <Button 
                type="secondary"
                className={style.logout}
                text={t("header.logoutButton")}
                small
                iconPosition="trailing"
                ssrIcon={logoutIcon} 
                onClick={(e) => logout(e)}
              />
            </div>
          </aside>
          <div className={`${style.overlay} ${clicked ? style.open : ''}`}></div>
        </div>
      </div>

      <MotionLevelSelector
      show={showSelector}
      level={levelSelected}
      hide={() => setShowSelector(!showSelector)}
      />
    </>
  )
}
